import { render } from "./AuthenticateCallerSMS.vue?vue&type=template&id=32ffeeec&scoped=true&ts=true"
import script from "./AuthenticateCallerSMS.vue?vue&type=script&lang=ts"
export * from "./AuthenticateCallerSMS.vue?vue&type=script&lang=ts"

import "./AuthenticateCallerSMS.vue?vue&type=style&index=0&id=32ffeeec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ffeeec"]])

export default __exports__